module.exports = __webpack_public_path__ + "img/img8.3dec3ff0.png";